export default "__VITE_ASSET__CWm1_i81__"